import { Component } from '@angular/core';
import { Alert, AlertController, ViewController, NavController } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import { APP_TITLE } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { App } from "ionic-angular";

@Component({
  selector: 'new-company',
  templateUrl: 'new-company.html'
})
export class NewCompanyPage {
  name: string;
  adminName: string;
  adminEmail: string;
  code: string;
  town: string;
  state: string;
  zipCode: string;
  phoneNumber: string;
  address: string;
  phoneMask: Array<string|RegExp>;
  zipMask: Array<string|RegExp>;
  constructor(
    private _app: App,
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private navCtrl: NavController,
    public httpService: HttpService
  ) {
    this.phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    this.zipMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }
  eventHandler(keyCode){
    if(keyCode==13){
      let activeElement = <HTMLElement>document.activeElement;
      activeElement && activeElement.blur && activeElement.blur();
    }
  }
  submitForm(): void {
    // TODO add visual aid for client side verification;
    // user should probably not be able to press the submit button
    // unless all required fields are present
    const { name, adminName, adminEmail } = this;
    if (!(name && adminName && adminEmail)) {
      const alert = this.alertCtrl.create({
        buttons: ['OK'],
        message: 'Not all required fields are filled in',
        title: 'Oops!'
      });

      alert.present();
      return;
    }

    const { code, town, state, zipCode, phoneNumber, address } = this;
    /*
    MeteorObservable.call('addCompany', {
      name,
      adminName,
      adminEmail,
      code,
      address,
      town,
      state,
      zipCode: (zipCode || '').replace(/[^\d]/g, ''),
      phoneNumber: (phoneNumber || '').replace(/[^\d]/g, ''),
    }).subscribe({
      next: () => {
        this.viewCtrl.dismiss();
      },
      error: (e: Error) => {
        this.viewCtrl.dismiss().then(() => {
          this.showError(e);
        });
      }
    });
    */

    this.httpService.MeteorCall(
      'addCompany',
      {
        name,
        adminName,
        adminEmail,
        code,
        address,
        town,
        state,
        zipCode: (zipCode || '').replace(/[^\d]/g, ''),
        phoneNumber: (phoneNumber || '').replace(/[^\d]/g, ''),
      }
    ).then(() => {
      this.viewCtrl.dismiss();
    })
    .catch((e: Error) => {
      this.viewCtrl.dismiss().then(() => {
        this.showError(e);
      });
    });
  }

  showError(err: Error): void {
    console.error('Error with newCompany', err);

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: err.message,
      title: 'Oops!'
    });

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/new-company/new-company.ts